import { Globe } from 'lucide-react';

const RegionSwitcher = () => {

  return (
    <a
      href="https://mtli.ca"
      className="inline-flex items-center gap-2 h-8 px-3 rounded-md text-sm hover:bg-accent transition-colors"
    >
      <Globe className="h-4 w-4" />
      <span className="text-xs font-medium">🇨🇦 Visit mtli.ca</span>
    </a>
  );
};

export default RegionSwitcher;
